"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookie = void 0;
function setCookie(name, value, domain, time) {
    let expires = '';
    if ((typeof time === 'number') && (time !== Infinity) && !isNaN(time)) {
        const date = new Date();
        date.setTime(date.getTime() + time);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + '; path=/; domain=' + domain + expires;
}
exports.setCookie = setCookie;
//# sourceMappingURL=SetCookie.js.map